import { DISTANCE_OPTIONS, useTranslation } from "hhn-commons";
import Chips from "../../../../common/Chips/Chips";
import { DistanceChipsWrapper } from "./AdvanceSearchList.style";

interface FilterByDistanceChipsProps {
  onSelectDistance: (distance: number) => void;
  selectedDistance: number;
}

const MilesChips = Chips<number>;

function DistanceChips({
  onSelectDistance,
  selectedDistance,
}: FilterByDistanceChipsProps) {
  const { t } = useTranslation();
  const tNAdvanceSearch = (key: string) => t(key, { ns: "advanceSearch" });

  return (
    <DistanceChipsWrapper>
      <MilesChips
        onSelectChip={onSelectDistance}
        selectedChip={selectedDistance}
        label={tNAdvanceSearch("distance")}
        options={DISTANCE_OPTIONS}
        name="distance"
      />
    </DistanceChipsWrapper>
  );
}

export default DistanceChips;
